module.exports = __webpack_public_path__ + "img/RepGuideLogoNoTextWhite.5402596d.svg";